export { ClockAlt as default } from './ClockAlt';
